// Ukrainian, uk-UA

export default {
	TOGGLE_DRAWER: `Показати або сховати меню`,
	UNFAVORITE: `Прибрати з улюблених`,
	__ASK_FOR_HELP: `* Попросити допомогу`,
	__TIME_IS_UP: `* Час вичерпано`,
	A_NEW_SUBSCRIPTION_WILL_BE_CREATED: `Будь ласка, створіть нову підписку`,
	ACCOUNT_CREATED_WELCOME: `Ласкаво просимо! Ми створили для вас новий обліковий запис.`,
	ACCOUNT_LOGIN: `Вхід в обліковий запис`,
	ACCOUNT_REGISTRATION: `Реєстрація облікового запису`,
	ACTION_FAILED: `Дія не вдалася`,
	ACTION_MENU: `Меню дій`,
	ACTION_WAS_SUCCESSFUL: `Дія була успішною`,
	ACTIVE: `Активний`,
	ACTIVE_SUBSCRIPTIONS: `Активні підписки`,
	ADD: `Додати`,
	ADD_NEW: `דодати новий`,
	ADD_NEW_ASSIGNMENT: `Додати нове завдання`,
	ADD_TO_FAVORITES: `Додати в обране`,
	ADD_USER: `דודати користувача`,
	ADDRESS: `Адреса`,
	ADVANCED_SEARCH: `Розширений пошук`,
	AFTER_A_MISTAKE: `Після помилки`,
	ANDROID_INSTALL_UNAVAILABLE_CAPTION: `Відкрийте меню браузера (⋮) і виберіть «Установити застосунок» або «Додати на головний екран».`,
	ANDROID_INSTALL_UNAVAILABLE_MESSAGE: `Вікно встановлення зараз недоступне`,
	AN_ERROR_MESSAGE_WILL_BE_SHOWN: `Буде показано повідомлення про помилку`,
	ANSWER: `Відповідь`,
	APPEARANCE: `Вигляд`,
	APPLY: `Застосувати`,
	APP_INSTALLED_SUCCESSFULLY: `Додаток встановлено успішно!`,
	APPROVE: `Схвалити`,
	APPROVE_NOTIFICATIONS_REQUEST: `Для отримання сповіщень про оновлення та запити вам потрібно схвалити сповіщення додатка. Хочете побачити сповіщення? (Схвалити запит)`,
	APPROVED: `СХВАЛЕНО`,
	ARE_YOU_SURE_REMOVE_USER_COURSE: `Ви впевнені, що хочете видалити цей курс зі своїх курсів? Весь ваш прогрес буде втрачено.`,
	ARE_YOU_SURE_YOU_WANT_TO_DELETE: `Ви впевнені, що хочете видалити`,
	ARE_YOU_SURE_YOU_WANT_TO_TOGGLE_ACTIVE: `Ви впевнені, що хочете змінити стан активності`,
	ARE_YOU_SURE_YOU_WANT_TO_TOGGLE_PERIOD: `Ви впевнені, що хочете змінити період, наступний платіж буде відповідати зміненому періоду.`,
	ARE_YOU_SURE_YOU_WANT_TO_UNSUBSCRIBE: `Ви впевнені, що хочете скасувати підписку? Більше платежів не буде. Ліцензія буде доступна до кінця періоду.`,
	ASSIGN: `Призначити`,
	ASSIGN_LICENSE_TO_CHILD: `Призначити ліцензію дитині`,
	ASSIGNMENTS: `Призначення`,
	ASSIGNED_COURSES: `Призначені курси`,
	ASSIGNED_SECTIONS: `Призначені завдання`,
	AT: `В`,
	AUDIO_SETTINGS: `Налаштування звуку`,
	AUTHENTICATION_FAIL: `Аутентифікація не вдалася`,
	AVAILABLE_ANSWERS: `Доступні відповіді`,
	AVERAGE_SCORE: `Середній бал`,
	AVATAR: `Аватар`,
	AVATAR_MANAGEMENT: `Управління аватаром`,
	AVATAR_SAVED_SUCCESS: `Аватар успішно збережено!`,
	AVATAR_SAVED_ERROR: `Не вдалося зберегти аватар`,
	AVATAR_DELETED_SUCCESS: `Аватар успішно видалено!`,
	AVATAR_DELETED_ERROR: `Не вдалося видалити аватар`,
	AVATAR_DOWNLOAD_PNG: `Завантажити PNG`,
	AVATAR_DOWNLOAD_SVG: `Завантажити SVG`,
	AVATAR_RANDOMIZE: `Випадковий вибір`,
	AVATAR_RESTORE_SAVED: `Відновити збережений аватар`,
	AVATAR_SAVE_TO_PROFILE: `Зберегти в профіль`,
	BACK: `Назад`,
	BACK_TO_LOGIN: `Повернутися до входу`,
	BACK_TO_STEP_LIST: `Повернутися до списку кроків`,
	BILLING: `Білінг`,
	BILLING_SETTINGS: `Налаштування білінгу`,
	BIRTH_DATE: `Дата народження`,
	BLANK_NOT_FOUND: `Пропуск не знайдено`,
	BLOCK_USER: `Заблокувати користувача`,
	BUY_LICENSE: `Купити ліцензію`,
	CANCEL: `Скасувати`,
	CANCELED: `Скасовано`,
	CANCLE: `Скасувати`,
	CATEGORY_BREAKDOWN: `Розподіл за категоріями`,
	CHANGE_PASSWORD: `Змінити пароль`,
	CHECKOUT: `Оформлення замовлення`,
	CHILD_ACCOUNT: `Обліковий запис дитини`,
	CHILD_ACCOUNT_LOGIN: `Вхід в обліковий запис дитини`,
	CHILD_LOGIN_TOKEN_INSTRUCTIONS: `Скопіюйте наведений нижче токен входу та надішліть його своїй дитині. Ваша дитина використовуватиме цей токен для входу до свого облікового запису.`,
	CHILD_LOGIN_CARD_STEP_1: `Дитина отримує код входу від батьків.`,
	CHILD_LOGIN_CARD_STEP_2: `Дитина введе код на сторінці входу та перейде до входу.`,
	CHILD_LOGIN_CARD_TITLE: `Як увійти до свого облікового запису?`,
	CHILDREN_MANAGEMENT: `Управління дітьми`,
	CHILD_LOGIN_TOKEN_NOT_FOUND: `Коду для входу ще немає. Створіть його для дитини.`,
	CHILED_LOGIN_TOKEN: `Токен входу дитини`,
	CHOOSE_A_PLAN: `Виберіть план`,
	CITY: `Місто`,
	CLASS: `Клас`,
	CLEAR_ALL: `Очистити все`,
	CLEAR_NOW: `Очистити зараз`,
	CLEAR_STORAGE: `Очистити пам'ять додатку`,
	CLEAR_STORAGE_DESCRIPTION: `Якщо додаток працює неправильно, очищення пам'яті додатку може допомогти.`,
	CLEAR_STORAGE_WARNING: `Ваш прогрес у курсі та ваша особиста інформація не будуть впливати на це`,
	CLOSE: `Закрити`,
	CODE_COPIED: `Код скопійовано`,
	COLLAPSE: `Згорнути`,
	COLLAPSE_SIDEBAR: `Згорнути бічну панель`,
	COMMENT: `Коментар`,
	COMPLETED: `Завершено`,
	COMPLETED_COURSES: `Завершені курси`,
	COMPLETED_SECTIONS: `Завершені завдання`,
	COMPLETED_STEPS: `Завершені кроки`,
	COMPLETED_STEP_BANNER_MESSAGE: `Чи хочете ви перейти до наступного кроку?`,
	COMPLETED_STEP_BANNER_TEXT: `Ви успішно завершили цей крок`,
	COMPLETE_STEP: `Завершити крок`,
	COMPLETION_FEEDBACK: `Відгук про завершення`,
	CONFIRM: `Підтвердити`,
	CONFIRM_NEW_PASSWORD: `Підтвердіть новий пароль`,
	CONFIRM_UNSUBSCRIBE: `Підтвердити скасування підписки`,
	CONTENT_EMPTY_COURSE_CHILD: `У вас ще немає курсів. Відвідайте магазин курсів і виберіть курс, щоб почати.`,
	CONTENT_EMPTY_COURSE_STUDENT: `У вас ще немає курсів. Учитель призначає курси вашому класу — попросіть учителя призначити вам курс.`,
	CONTENT_EMPTY_COURSE_TITLE: `Курсів ще немає`,
	CONTENT_EMPTY_GENERIC: `Тут поки що нічого показати.`,
	CONTENT_EMPTY_SECTION_CHILD: `У вас ще немає завдань. Відвідайте магазин і виберіть завдання, щоб почати.`,
	CONTENT_EMPTY_SECTION_STUDENT: `У вас ще немає завдань. Учитель призначає завдання вашому класу — попросіть учителя призначити вам завдання.`,
	CONTENT_EMPTY_SECTION_TITLE: `Завдань ще немає`,
	CONTENT_EMPTY_TEACHER_PREVIEW: `Ви ще нічого не переглядали. Відкрийте один із своїх класів і натисніть «Попередній перегляд» на призначеному курсі або завданні.`,
	COPIED_TO_CLIPBOARD: `Скопійовано в буфер обміну`,
	COPY_CODE: `Скопіювати код`,
	COPY_TO_CLIPBOARD: `Скопіювати в буфер обміну`,
	CORRECT: `Правильно`,
	CORRECT_ANSWER: `Правильна відповідь`,
	COUNTRY: `Країна`,
	COURSE: `Курс`,
	COURSE_ASSIGNED_SUCCESSFULLY: `Курс успішно призначено`,
	COURSE_COMPLETED: `Курс завершено`,
	COURSE_NAME: `Назва курсу`,
	COURSE_TYPE_FREE: `Безкоштовний`,
	COURSE_TYPE_PREMIUM: `Преміум`,
	COURSE_PREVIEW: `Перегляд курсів`,
	COURSE_REMOVED_SUCCESSFULLY: `Курс успішно видалено`,
	COURSE_SECTION: `Завдання курсу`,
	COURSE_SECTIONS: `Завдання курсу`,
	COURSE_STORE: `Магазин курсів`,
	COURSES: `Курси`,
	CROSSMATCH: `CrossMatch`,
	CURRENT_STREAK: `Поточна серія`,
	CURRENT_PASSWORD: `Поточний пароль`,
	DAILY: `Щоденно`,
	DASHBOARD: `Панель інструментів`,
	DATE: `Дата`,
	DAY: `День`,
	DAYS_AGO: `{count} дн. тому`,
	DELETE: `Видалити`,
	DELETE_USER: `Видалити користувача`,
	DETAILS: `Деталі`,
	DIGITS_ONLY: `Тільки цифри`,
	DISMISS: `Відхилити`,
	DONT_HAVE_AN_ACCOUNT: `У вас немає облікового запису`,
	DRILL: `Вправа`,
	DRILL_DESCRIPTION: `Опис вправи`,
	DRILL_TYPE: `Тип вправи`,
	EDIT: `Редагувати`,
	EDIT_DETAILS: `Редагувати деталі`,
	EDIT_USER: `Редагувати користувача`,
	EDIT_USER_DETAILS: `Редагувати деталі користувача`,
	EMAIL: `Електронна пошта`,
	ENABLE_EDITING: `Увімкнути редагування`,
	END_ALL: `Завершити завдання`,
	ENROLLMENT_STATUS_ACTIVE_ACTION: `Нічого робити не потрібно — виберіть цей клас у фільтрі, щоб бачити лише його курси та завдання.`,
	ENROLLMENT_STATUS_ACTIVE_MESSAGE: `Вас зараховано до цього класу. Його курси та завдання вже доступні.`,
	ENROLLMENT_STATUS_COMPLETED_ACTION: `Нічого робити не потрібно — молодець. Щоб приєднатися до нового класу, попросіть у вчителя запрошення.`,
	ENROLLMENT_STATUS_COMPLETED_MESSAGE: `Ви завершили цей клас. Його курси та завдання більше не входять до ваших активних завдань.`,
	ENROLLMENT_STATUS_DECLINED_ACTION: `Уточніть у вчителя, чи правильний клас ви обрали, і попросіть нове запрошення.`,
	ENROLLMENT_STATUS_DECLINED_MESSAGE: `Ваш запит на приєднання до цього класу відхилено, тому доступу до його матеріалів у вас немає.`,
	ENROLLMENT_STATUS_DROPPED_ACTION: `Зверніться до вчителя, якщо вважаєте, що це помилка — він може зарахувати вас знову.`,
	ENROLLMENT_STATUS_DROPPED_MESSAGE: `Вас виключено з цього класу, тому його курси та завдання більше вам не призначені.`,
	ENROLLMENT_STATUS_PENDING_ACTION: `Попросіть учителя підтвердити ваш запит. Від вас більше нічого не потрібно.`,
	ENROLLMENT_STATUS_PENDING_MESSAGE: `Ваш запит на приєднання до цього класу очікує підтвердження вчителя. До того часу його курси та завдання приховані.`,
	ENROLLMENT_STATUS_UNKNOWN_ACTION: `Спробуйте оновити сторінку. Якщо це повторюється, попросіть учителя перевірити ваше зарахування.`,
	ENROLLMENT_STATUS_UNKNOWN_MESSAGE: `Не вдалося визначити статус цього зарахування.`,
	ENROLLMENT_STATUS_WHAT_TO_DO: `Що можна зробити`,
	ENTER: `Вхід`,
	ENTER_YOUR_EMAIL_ADDRESS: `Введіть свою електронну адресу`,
	ERROR: `Помилка`,
	ERROR_ASSIGNING_COURSE: `Помилка призначення курсу`,
	ERROR_FETCHING_DATA: `Помилка завантаження даних`,
	ERROR_NO_ACCOUNT_FOR_EMAIL: `Для цієї електронної пошти немає облікового запису. Попросіть школу створити його, а потім увійдіть.`,
	ERROR_NO_ACTIVE_ENROLLMENT: `У вас немає активного зарахування на поточний семестр`,
	ERROR_REMOVING_COURSE: `Помилка видалення курсу`,
	EXIT: `Вихід`,
	EXP: `Термін дії`,
	FAILED: `Невдалося`,
	FAILED_TO_COPY: `Не вдалося скопіювати`,
	FAILED_TO_RESET_PASSWORD: `Не вдалося скинути пароль`,
	FAILED_TO_SEND_RESET_EMAIL: `Не вдалося надіслати електронний лист для скидання`,
	FALSE: `Неправильно`,
	FAMILY: `Сім'я`,
	FATHER: `Батько`,
	FAVORITE: `Улюблений`,
	FAVORITE_COURSE: `Улюблений курс`,
	FEMALE: `Жінка`,
	FILL_IN_THE_BLANK: `Заповніть поле`,
	FILTERS: `Фільтри`,
	FILTER_STEP: `Фільтрувати крок`,
	FILTER_STEPS: `Фільтрувати кроки`,
	FINAL_SCORE: `Підсумковий бал`,
	FIRST_ATTEMPT_SCORE: `Бал за першу спробу`,
	FIRST_NAME: `Ім'я`,
	FLASH_SCHOOL_OF_ENGLISH: `flash school of english`,
	FLASH_STUDIES: `Flash Studies`,
	FOR: `для`,
	FOR_A_WEEK_PLEASE_FILL_IN_THE_PAYMENT_INFORMATION: `на тиждень, будь ласка, заповніть інформацію про оплату`,
	FOR_CHILD: `Для дитини`,
	FORGOT_PASSWORD: `Забули пароль`,
	FORGOT_PASSWORD_ERROR: `Помилка забутого пароля`,
	FREE_TRIAL: `Безкоштовна пробна версія`,
	FROM: `from`,
	FULL_NAME: `Повне ім'я`,
	GENERATE_ONE_TIME_TOKEN_FOR_CHILD: `Згенерувати одноразовий токен для дитини`,
	GET_HELP: `Допомога`,
	GET_PLAN: `Отримати план`,
	GO_BACK: `Повернутися`,
	GO_TO_CLASSES: `Перейти до класів`,
	GO_TO_CHILDREN: `Перейти до дітей`,
	GO_TO_COURSE_STORE: `Перейти до магазину курсів`,
	GO_TO_MY_CLASSES: `Перейти до моїх класів`,
	GO_TO_MY_COURSE: `Перейти до мого курсу`,
	GO_TO_MY_COURSES: `Перейти до моїх курсів`,
	GO_TO_STORE: `Перейти до магазину`,
	GO_TO_NEXT: `перейти до наступного`,
	GO_TO_PREVIOUS: `перейти до попереднього`,
	GOOD_AFTERNOON: `Добрий день`,
	GOOD_EVENING: `Добрий вечір`,
	GOOD_MORNING: `Доброго ранку`,
	GOOD_NIGHT: `Доброй ночи`,
	HAVE_AN_ACCOUNT: `У вас є обліковий запис?`,
	HELP: `Допомога`,
	HELP_USAGE: `Використання підказок`,
	HIDDEN_QUESTION: `Приховане питання`,
	HIDDEN_SENTENCE: `Прихований текст`,
	HIDE: `Приховати`,
	HIDE_ADVANCED_SEARCH: `Приховати розширений пошук`,
	HIDE_COMMENTS: `Приховати коментарі`,
	HIDE_COMPLETED: `Приховати завершені`,
	HOUR: `Година`,
	IDENTIFICATION_NUMBER: `Ідентифікаційний номер`,
	IF_EMAIL_EXISTS_RESET_LINK_SENT: `Якщо ця електронна адреса існує, було надіслано посилання для скидання.`,
	IN_PROGRESS: `у процесі`,
	INACTIVE: `Неактивний`,
	INCOMPLETE: `Незавершено`,
	INFORMATION: `Інформація`,
	INSTALL: `Встановити`,
	INSTALL_APP: `Встановити додаток`,
	INSTALL_APP_PROMPT_CAPTION: `Отримайте швидший доступ та офлайн-функції`,
	INSTALL_APP_PROMPT_MESSAGE: `Встановити додаток SET`,
	IOS_INSTALL_TITLE: `Встановлення на iPhone / iPad`,
	IOS_INSTALL_STEP0: `Встановлення додатка можливо лише через Safari`,
	IOS_INSTALL_STEP1: `Відкрийте Safari і перейдіть на цей сайт`,
	IOS_INSTALL_STEP2: `Натисніть кнопку [Поділитися] (квадрат зі стрілкою)`,
	IOS_INSTALL_STEP3: `Виберіть «Додати на екран додому», потім натисніть «Додати»`,
	IOS_INSTALL_NOTE: `Після додавання відкрийте додаток з екрана головного меню`,
	INSTRUCTIONS: `Інструкції`,
	INTERIM_RESULTS: `Проміжні результати`,
	INVALID_NAME_FORMAT: `Ім'я може містити лише літери, пробіли, дефіси та апострофи`,
	INVALID_VALUE: `Недійсне значення`,
	IT_WAS_WRITTEN_AS_AN_ERROR_AND_IMPACT_YOUR_SCORE: `Це було записано як помилка і вплине на ваш бал`,
	IT_WILL_COUNT_AS_AN_ERROR: `Це буде враховуватися як помилка`,
	IT_WILL_NOT_COUNT_AS_AN_ERROR: `Це не буде враховуватися як помилка`,
	LANGUAGE_SELECT: `Мова`,
	LAST_NAME: `Прізвище`,
	LAST_PRACTICE: `Останнє заняття`,
	LATER: `Пізніше`,
	LICENSE: `Ліцензія`,
	LICENSE_ASSIGNED_SUCCESSFULLY_TO_CHILD: `Ліцензія успішно призначена дитині`,
	LICENSE_EXPIRED: `Ліцензія закінчилася`,
	LICENSE_REQUIRED_FOR_PREMIUM: `Цей преміум-курс потребує активної ліцензії.`,
	LICENSE_REQUIRED_REDIRECT_COURSES: `Ваша ліцензія недійсна для преміум-контенту. Перенаправляємо до магазину курсів.`,
	LICENSE_VALID_UNTIL: `Ліцензія дійсна до`,
	LICENSES: `Ліцензії`,
	LOCKED_FOR_STUDENTS: `Заблоковано для учнів`,
	LOCKED_PREMIUM_COURSE: `Преміум заблоковано`,
	LOCATION: `Місце розташування`,
	LOGIN: `Вхід`,
	LOGIN_TOKEN: `Токен входу`,
	LOGOUT: `Вихід`,
	LONGEST_STREAK: `Найдовша серія`,
	MAIN_ACCOUNT: `головний акаунт`,
	MALE: `Чоловік`,
	MANUAL_COPY_INSTRUCTION: `Будь ласка, виберіть увесь текст нижче та скопіюйте його вручну:`,
	MAXIMUM_50_CHARACTERS: `Не більше 50 символів`,
	MAX_AGE: `Максимальний вік`,
	MAX_CHARACTERS: `Максимальна кількість символів`,
	MEMORY_FLIP: `Гра на пам'ять`,
	MESSAGES: `Повідомлення`,
	MIC_NOT_SUPPORTED: `Говоріння не підтримується в цьому браузері — введіть відповідь`,
	MIN_AGE: `Мінімальний вік`,
	MIN_CHARACTERS: `Мінімальна кількість символів`,
	MOBILE_NOT_FOUND: `Мобільний не знайдено`,
	MOBILE_NUMBER: `Мобільний номер`,
	MOBILE_NUMBER_10_DIGITS: `Мобільний номер, 10 цифр`,
	MOBILE_PHONE: `Мобільний телефон`,
	MONTH: `Місяць`,
	MONTHLY: `Щомісячно`,
	MOTHER: `Мати`,
	MY_CLASSES: `Мої класи`,
	MY_COURSES: `Мої курси`,
	MY_FAVORITES: `Мої улюблені`,
	MY_PROFILE: `Мій профіль`,
	MY_PROFILE_DETAILS: `Деталі мого профілю`,
	MY_SECTIONS: `Мої завдання`,
	MY_STEPS: `Мої кроки`,
	NAME: `Ім'я`,
	NAME_2_TO_64: `2 до 64 символів`,
	NAVIGATION_MENU: `Меню навігації`,
	NEW_MESSAGE: `Нове повідомлення`,
	NEW_PASSWORD: `Новий пароль`,
	NEW_TO_OUR_SYSTEM: `Новий у нашій системі?`,
	NEW_USER: `Новий користувач`,
	NEXT: `Наступний`,
	NEXT_STEP: `Наступний крок`,
	NO: `Ні`,
	NO_CHILDREN_AVAILABLE: `Немає доступних дітей`,
	NO_COURSES_AVAILIABLE_IN_STORE: `Немає курсів у магазині`,
	NO_DATA_AVAILIABLE: `Дані недоступні`,
	NO_ERROR_MESSAGE_WILL_BE_SHOWN: `Не буде показано повідомлення про помилку`,
	NO_FEEDBACK_AVAILABLE: `Відгук недоступний`,
	NO_LICENSE: `Немає ліцензії`,
	NO_TASKS_MATCH_FILTERS: `Немає завдань, що відповідають фільтрам`,
	NO_VALID_PAYMENT_DATA_FOUND_CHECKOUT_TO_PAY: `Не знайдено дійсних платіжних даних, оформлення замовлення для оплати`,
	NOT_SET: `Не встановлено`,
	NOT_STARTED: `Не почато`,
	NOTIFICATIONS_APPROVED: `Сповіщення схвалено!`,
	NOTIFICATIONS_WERE_NOT_APPROVED: `Сповіщення не схвалені, ви можете змінити це, натиснувши значок на панелі адреси (перед URL) та вибравши «налаштування сайту», потім знайдіть дозволи «Сповіщення» та встановіть їх.`,
	NO_FAVORITES_AVAILABLE: `Обраного ще немає`,
	OF: `з`,
	OKAY: `Добре`,
	OOPS_THIS_IS_THE_WRONG_ANSWER: `Ой! це неправильна відповідь`,
	ORGANIZATION: `Організація`,
	ORGANIZATION_DETAILS: `Деталі організації`,
	ORGANIZATION_NAME: `Назва організації`,
	ORGANIZATION_TYPE: `Тип організації`,
	ORGANIZATIONS: `Організації`,
	ORGANIZATIONS_LIST: `Список організацій`,
	OTHER: `Інший`,
	OWNED: `Власність`,
	PAIRS: `Пари`,
	PARENT_ACCOUNT_LOGIN: `Вхід в обліковий запис батьків`,
	PASSWORD: `Пароль`,
	PASSWORD_RESET_SUCCESSFUL: `Пароль успішно скинуто`,
	PASSWORD_UPDATED: `Пароль оновлено`,
	PASSWORDS_MUST_MATCH: `Паролі повинні співпадати`,
	PAUSE: `Пауза`,
	PAYMENT: `Оплата`,
	PAYMENT_CONFIRMATION_TEXT: `Обробка вашого платежу може зайняти до 10 хвилин. Тим не менш, ми активуємо вашу ліцензію, якщо платіж буде відхилено, ліцензія буде деактивована.`,
	PAYMENT_CONFIRMATION_TITLE: `Замовлення отримано`,
	PERIOD: `Період`,
	PHONE: `Телефон`,
	PHONE_NUMBER: `Номер телефону`,
	PITCH: `Висота`,
	PLAN: `План`,
	PLAN_ERROR: `Помилка плану`,
	PLAN_INFORMATION: `Інформація про план`,
	PLEASE_ENTER_A_VALID_EMAIL_ADDRESS: `Будь ласка, введіть дійсну адресу електронної пошти`,
	PLEASE_ENTER_A_VALID_PASSWORD: `Будь ласка, введіть дійсний пароль`,
	PLEASE_ENTER_A_VALUE: `Будь ласка, введіть значення`,
	PRACTICE: `Практика`,
	PRESS_THE_PLAY_BUTTON_TO_HERE_THE_QUESTION: `Натисніть кнопку відтворення, щоб почути питання`,
	PRICE: `Ціна`,
	PREVIEW: `Попередній перегляд`,
	PREVIEW_FAILED: `Не вдалося відкрити попередній перегляд`,
	PROCESSING: `Обробка...`,
	PROFILE: `Профіль`,
	PROFILE_SETTINGS: `Налаштування профілю`,
	PROGRESS_OVERVIEW: `Огляд прогресу`,
	PROGRESS_SAVE_FAILED: `Не вдалося зберегти ваш прогрес. Перевірте підключення.`,
	PUT_THE_WORDS_IN_ORDER: `Розставте слова в правильному порядку`,
	QUERY: `Запит`,
	RATE: `Оцінка`,
	RECIEVE_NOTIFICATIONS: `Отримувати сповіщення`,
	REDO_CURRENT: `повторити поточний`,
	REDO_SECTION: `повторити завдання`,
	REGISTER: `Зареєструватися`,
	REGISTRATION: `Реєстрація`,
	REJECTED: `Відхилений`,
	RECENT_ACTIVITY: `Остання активність`,
	REMOVE_COURSE: `Видалити курс`,
	REMOVE_FROM_FAVORITES: `Видалити з обраного`,
	REQUESTED: `ЗАПИТАНО`,
	REQUIRED: `Це поле обов'язкове`,
	RESET: `Скидання`,
	RESET_CODE_MISSING: `Код скидання відсутній`,
	RESET_PASSWORD: `Скинути пароль`,
	RESET_PASSWORD_ERROR: `Помилка скидання пароля`,
	RESET_STEP: `Скидання кроку`,
	RESTART_COURSE: `Перезапустити курс`,
	RESTART_SECTION: `Перезапустити завдання`,
	RETRY: `Спробувати ще раз`,
	RETYPE_PASSWORD: `Повторіть пароль`,
	ROLE: `Роль`,
	SAVE: `Зберегти`,
	SAY_YOUR_ANSWER: `Натисніть мікрофон і скажіть відповідь`,
	SCHOOL: `Школа`,
	SCHOOL_ACCOUNT_LOGIN: `Вхід до шкільного облікового запису`,
	SCHOOL_ACCOUNT_REGISTRATION: `Реєстрація шкільного облікового запису`,
	SCHOOL_ADMIN_ACCOUNT: `Обліковий запис адміністратора школи`,
	SCHOOL_ALL_CLASSES: `Усі класи`,
	SCHOOL_ALL_SCHOOLS: `Усі школи`,
	SCHOOL_ALLOW_FUTURE_ASSIGNMENTS: `Дозволити призначення наперед`,
	SCHOOL_ALL_SEMESTERS: `Усі семестри`,
	SCHOOL_APPLICATION_CANCELLED: `Заявку скасовано`,
	SCHOOL_APPLIED: `Заявку подано`,
	SCHOOL_APPLY: `Подати заявку`,
	SCHOOL_APPLY_SUCCESS: `Заявку подано. Очікує на підтвердження вчителя.`,
	SCHOOL_ASSIGNED_COUNT: `Призначено`,
	SCHOOL_ASSIGNED_COURSES: `Призначені курси`,
	SCHOOL_ASSIGNED_LABEL: `Призначено`,
	SCHOOL_ASSIGNED_STUDENTS_COUNTER: `Призначено {assignedCount} з {totalCount} учнів`,
	SCHOOL_ASSIGN_COURSE: `Призначити курс`,
	SCHOOL_ASSIGN_INACTIVE_STUDENT: `Нові завдання можна призначати лише активним учням.`,
	SCHOOL_ASSIGN_LOCKED_FUTURE: `Цей семестр ще не почався. Увімкніть «Дозволити призначення наперед», щоб призначати курси та завдання.`,
	SCHOOL_ASSIGN_LOCKED_PAST: `Цей семестр завершився. Ви можете скасовувати призначення, але не додавати нові.`,
	SCHOOL_ASSIGN_LOCKED_SEMESTER: `Призначення заблоковано для цього семестру.`,
	SCHOOL_ASSIGN_COURSE_FAILED: `Не вдалося призначити курс класу`,
	SCHOOL_ASSIGN_COURSE_SUMMARY: `Призначено {createdCount} учням ({existingCount} вже були призначені)`,
	SCHOOL_ASSIGN_COURSE_TO_STUDENTS: `Призначити учням`,
	SCHOOL_BULK_ASSIGNMENT_SUMMARY: `Призначено {courseCount} курсів і {sectionCount} завдань для {studentCount} учнів ({changedCount} змін, {unchangedCount} без змін)`,
	SCHOOL_CANCEL_APPLICATION: `Скасувати заявку`,
	SCHOOL_CLASS_APPROVE: `Підтвердити`,
	SCHOOL_CLASS_COURSE_ASSIGNMENT: `Призначення курсу класу`,
	SCHOOL_CLASS_DECLINE: `Відхилити`,
	SCHOOL_CLASS_DROP: `Виключити`,
	SCHOOL_CLASS_DROP_CONFIRM: `Виключити {name} з цього класу? Це завершить запис на семестр.`,
	SCHOOL_CLASS_REINSTATE: `Поновити`,
	SCHOOL_CLASS_REINSTATE_CONFIRM: `Поновити {name} у цьому класі? Доступ до курсів відновиться, і прогрес продовжиться з того місця, де зупинився.`,
	SCHOOL_COMPLETED_COUNT: `Завершено`,
	SCHOOL_COPY_ENROLLMENT_LINK: `Скопіювати посилання на запис`,
	SCHOOL_COPY_REGISTRATION_LINK: `Скопіювати посилання на реєстрацію`,
	SCHOOL_CREATE_ENROLLMENT: `Створити зарахування`,
	SCHOOL_CURRENT_SEMESTER: `Поточний семестр: {name}`,
	SCHOOL_DECISION_SAVED: `Рішення збережено`,
	SCHOOL_ENROLLED: `Зараховано`,
	SCHOOL_ENROLLMENT_CREATE_SUCCESS: `Зарахування успішно створено`,
	SCHOOL_ENROLLMENT_DOCUMENT_ID: `ID документа зарахування`,
	SCHOOL_ENROLLMENT_LINK_COPIED: `Посилання на запис скопійовано`,
	SCHOOL_ENROLLMENT_LINK_EXPLAIN: `Для студентів, які вже мають обліковий запис — один клік надсилає запит на вступ до класу, який ви потім підтверджуєте.`,
	SCHOOL_ENROLLMENT_STATUS_LABEL: `Зарахування: {status}`,
	SCHOOL_FIND_CLASSES: `Пошук класів`,
	SCHOOL_HIDE_INACTIVE_STUDENTS: `Сховати неактивних`,
	SCHOOL_INVITE_CLOSED_PAST_SEMESTER: `Посилання-запрошення недоступні для семестру, який завершився.`,
	SCHOOL_INVITE_FOR_SEMESTER: `На семестр: {name}`,
	SCHOOL_INVITE_LINKS: `Посилання-запрошення`,
	SCHOOL_INVITE_LINKS_HINT: `Поділіться посиланням, щоб додати студентів до цього класу.`,
	SCHOOL_JOIN_ERROR_CLASS_NOT_FOUND: `Не вдалося знайти цей клас. Можливо, посилання-запрошення недійсне або клас більше недоступний.`,
	SCHOOL_JOIN_ERROR_CLOSED: `Це запрошення більше не можна використати для приєднання до класу.`,
	SCHOOL_JOIN_ERROR_COMPLETED: `Ви вже завершили цей клас, тож приєднуватися немає до чого.`,
	SCHOOL_JOIN_ERROR_DECLINED: `Ваш запит на приєднання до цього класу відхилено. Попросіть у вчителя нове запрошення.`,
	SCHOOL_JOIN_ERROR_DROPPED: `Вас видалено з цього класу. Зверніться до вчителя, якщо вважаєте, що це помилка.`,
	SCHOOL_JOIN_ERROR_GENERIC: `Під час приєднання до класу сталася помилка. Спробуйте ще раз.`,
	SCHOOL_JOIN_ERROR_INVALID_LINK: `Це посилання-запрошення недійсне або його термін дії минув.`,
	SCHOOL_JOIN_ERROR_SEMESTER_ENDED: `Семестр цього класу завершився, тому запис на нього закрито.`,
	SCHOOL_JOIN_ERROR_TITLE: `Не вдалося приєднатися до класу`,
	SCHOOL_JOIN_GO_HOME: `Перейти до панелі`,
	SCHOOL_JOIN_RETRY: `Спробувати ще раз`,
	SCHOOL_JOIN_STUDENTS_ONLY: `Приєднатися до класу можуть лише студенти.`,
	SCHOOL_JOIN_SUCCESS: `Запит надіслано — вчитель має вас підтвердити.`,
	SCHOOL_LOGIN_ROLE_MISMATCH: `Вибрана роль не відповідає ролі вашого облікового запису.`,
	SCHOOL_NO_ASSIGNED_CLASSES_FOUND: `Призначених класів не знайдено.`,
	SCHOOL_NO_CLASSES_ASSIGNED_IN_SEMESTER: `У цьому семестрі вам не призначено жодного класу.`,
	SCHOOL_NO_CLASSES_AVAILABLE: `Для цієї школи немає доступних класів.`,
	SCHOOL_NO_CLASSES_FOR_SELECTED_SEMESTER: `Для обраного семестру класи не знайдено.`,
	SCHOOL_NO_CURRENT_SEMESTER: `Зараз немає активного семестру. Запис закрито.`,
	SCHOOL_NO_ENROLLMENTS_FOR_THIS_SEMESTER: `Для цього семестру зарахувань не знайдено.`,
	SCHOOL_NO_STUDENTS_FOUND_FOR_CLASS: `Для цього класу учнів не знайдено`,
	SCHOOL_NO_STUDENTS_MATCH_FILTER: `Немає учнів, що відповідають вибраним статусам`,
	SCHOOL_NOT_ASSIGNED_LABEL: `Не призначено`,
	SCHOOL_NOTES: `Нотатки`,
	SCHOOL_PROGRESS_PAUSED_SHORT: `Прогрес призупинено`,
	SCHOOL_REGISTER_SUCCESS: `Шкільний обліковий запис створено. Увійдіть із вашими обліковими даними.`,
	SCHOOL_REGISTRATION_LINK_COPIED: `Посилання на реєстрацію скопійовано`,
	SCHOOL_REGISTRATION_LINK_EXPLAIN: `Для студентів без облікового запису — вони реєструються, і вам надходить запит на вступ до цього класу для підтвердження.`,
	SCHOOL_SCORE_LABEL: `Оцінка: {score}`,
	SCHOOL_SEMESTER_LABEL: `Семестр: {name}`,
	SCHOOL_SELECTED_COURSE: `Вибраний курс`,
	SCHOOL_SELECT_ASSIGNED_COURSE_TO_VIEW_PROGRESS: `Виберіть картку призначеного курсу, щоб переглянути прогрес учнів.`,
	SCHOOL_SELECT_SCHOOL: `Виберіть школу`,
	SCHOOL_SELECT_SEMESTER_TO_VIEW: `Виберіть семестр, щоб переглянути класи.`,
	SCHOOL_SHOW_INACTIVE_STUDENTS: `Показати неактивних ({count})`,
	SCHOOL_STATUS_ACTIVE: `Активний`,
	SCHOOL_STATUS_COMPLETED: `Завершено`,
	SCHOOL_STATUS_DECLINED: `Відхилено`,
	SCHOOL_STATUS_DROPPED: `Вибув`,
	SCHOOL_STATUS_PENDING: `Очікує`,
	SCHOOL_STUDENT_DOCUMENT_ID: `ID документа учня`,
	SCHOOL_STUDENTS_PROGRESS_FOR_COURSE: `Прогрес учнів у цьому курсі`,
	SCHOOL_STUDENTS_COUNT: `Учні`,
	SCHOOL_UNASSIGNED_PROGRESS_PAUSED_MESSAGE: `Прогрес для непризначеного контенту призупинено.`,
	SCHOOL_UPDATE_ENROLLMENT: `Оновити зарахування`,
	SCHOOL_ENROLLMENT_UPDATE_SUCCESS: `Зарахування успішно оновлено`,
	SCHOOL_LAST_ACTIVE: `Активність: {when}`,
	SCHOOL_NEVER_ACTIVE: `Ще не входив(-ла)`,
	SCHOOL_SELECT_ALL: `Вибрати всіх`,
	SCHOOL_UNASSIGN: `Скасувати призначення`,
	SCHOOL_UNASSIGN_COMPLETED_CONFIRM: `{name} вже завершив(-ла) {entity}. Скасування приховає матеріал; прогрес і оцінку буде збережено, вони повернуться після повторного призначення. Все одно скасувати?`,
	SCHOOL_UNASSIGN_STARTED_CONFIRM: `{name} вже розпочав(-ла) {entity}. Скасування не дасть продовжити; прогрес буде збережено, він повернеться після повторного призначення. Все одно скасувати?`,
	SCHOOL_UNASSIGN_STARTED_TITLE: `Учень уже розпочав`,
	SCHOOL_UNSELECT_ALL: `Зняти вибір`,
	SCORE: `Бал`,
	SEARCH: `Пошук`,
	SEARCH_BY_NAME: `Пошук за назвою`,
	SECTION: `Завдання`,
	SECTION_COMPLETED: `Завдання завершено`,
	SECTION_PREVIEW: `Перегляд завдань`,
	SECTION_STORE: `Магазин завдань`,
	SECTIONS: `Завдання`,
	SECURITY: `Безпека`,
	SECURITY_SETTINGS: `Налаштування безпеки`,
	SELECT: `Вибрати`,
	SELECTED_PLAN: `Вибраний план`,
	SELECT_ALL: `Вибрати все`,
	SELECT_AND_ASSIGN: `Вибрати й призначити`,
	SELECT_AND_COPY_TEXT_BELOW: `Виберіть і скопіюйте текст нижче`,
	SELECT_APPEARANCE: `Виберіть тему оформлення`,
	SELECT_CITY_FIRST: `Будь ласка, спочатку виберіть місто`,
	SELECT_LANGUAGE: `Виберіть мову`,
	SELECT_ONE_OPTION_TO_ANSWER: `Виберіть один варіант для відповіді`,
	SELECT_SYSTEM_LANGUAGE: `Виберіть мову системи`,
	SEND_REQUEST: `Надіслати запит`,
	SEND_RESET_LINK: `Надіслати посилання для скидання`,
	SENTENCE_BUILDER: `Склади речення`,
	SETTINGS: `Налаштування`,
	SEX: `Стать`,
	SEMESTER: `Семестр`,
	SEMESTER_TAG_CURRENT: `Поточний`,
	SEMESTER_TAG_PAST: `Минулий`,
	SEMESTER_TAG_UPCOMING: `Майбутній`,
	SHARE_CODE: `Поділитися кодом`,
	SHOW_COMMENTS: `Показати коментарі`,
	SHOW_INFO: `Показати інформацію`,
	SIGN_IN: `Увійти`,
	SIGN_IN_SUCCESS: `Усішний вхід`,
	SIGN_OUT: `Вийти`,
	SIGNING_IN: `Вхід`,
	SINGLE_CHOICE: `Одиночний вибір`,
	SKIP: `Пропустити`,
	SKIPPED: `Пропущено`,
	SOMETHING_WENT_WRONG: `Щось пішло не так`,
	SORT: `Сортування`,
	SORT_BY: `Сортувати за`,
	SORT_HIGHEST_SCORE_FIRST: `Спочатку найвищий бал`,
	SORT_LOWEST_SCORE_FIRST: `Спочатку найнижчий бал`,
	SORT_NAME_A_Z: `Назва А–Я`,
	SORT_RECENTLY_WORKED_ON: `Нещодавно опрацьовані`,
	SPEAK_THE_TEXT: `Проговоріть текст`,
	START: `Початок`,
	START_DATE: `Дата початку`,
	STATUS: `Статус`,
	STEP: `Крок`,
	STEP_INCOMPLETE_DATA: `Неповні дані кроку`,
	STEP_LOAD_ERROR: `Помилка завантаження кроку`,
	STEP_NOT_FOUND: `Крок не знайдено`,
	STEP_RESULTS: `Результати кроку`,
	STEPS: `Кроки`,
	STEP_FEEDBACK_GO_BACK_MESSAGE: `Поверніться до попереднього кроку, а потім спробуйте цей ще раз.`,
	STEP_FEEDBACK_GO_BACK_TITLE: `Повернімося на крок назад`,
	STEP_FEEDBACK_PASS_SCORE: `Щоб рухатися далі, потрібно {score}%.`,
	STEP_FEEDBACK_REDO_MESSAGE: `Попрацюймо над цим кроком ще раз.`,
	STEP_FEEDBACK_REDO_TITLE: `Спробуймо цей крок ще раз`,
	STEP_FEEDBACK_SCORE: `Ваш результат: {score}%.`,
	STOP: `Зупинити`,
	STORAGE_CLEARED_ERROR: `Не вдалося очистити пам’ять застосунку. Спробуйте ще раз.`,
	STORAGE_CLEARED_SUCCESS: `Пам'ять додатку успішно очищена`,
	STORAGE_CLEARED_SUCCESS_CAPTION: `Пам'ять додатку успішно очищена. Тепер ви можете перезапустити додаток.`,
	STREET: `Вулиця`,
	STREET_NUMBER: `Номер будинку`,
	STUDENT: `Учень`,
	STUDENT_ACCOUNT: `кабінет студента`,
	STUDENT_MY_CLASSES: `Мої класи`,
	STUDENT_NO_CLASSES: `Ви ще не зараховані до жодного класу. Попросіть у вчителя посилання для приєднання.`,
	STUDENT_NO_CLASSES_IN_SEMESTER: `Немає класів у цьому семестрі.`,
	STUDENT_SEMESTER_CURRENT: `Поточний семестр`,
	STUDENT_SEMESTER_UPCOMING: `Майбутній семестр`,
	STUDENT_STATISTICS: `Статистика учня`,
	STUDENTS: `Учні`,
	SUBMIT: `Подати`,
	SUBSCRIPTION_CREATED_SUCCESSFULLY: `Підписку успішно створено`,
	SUBSCRIPTION_UPDATED_SUCCESSFULLY: `Підписку успішно оновлено`,
	SUPER_ADMIN: `Супер адмін`,
	SYSTEM_LANGUAGE: `Мова системи`,
	TAKE_COURSE: `Взяти курс`,
	TEACHER_PREVIEW_BANNER: `Режим попереднього перегляду — ви бачите цей вміст так, як його бачитимуть ваші учні. Ваш прогрес тут не є прогресом учня.`,
	TEACHER_ACCOUNT: `Обліковий запис вчителя`,
	TEACHERS: `Учителі`,
	TERMS_OF_TRANSITION: `Умови переходу`,
	THEME_DARK: `Темна`,
	THEME_LIGHT: `Світла`,
	THEME_SYSTEM: `Системна`,
	THE_QUESTION_IS_HEARD: `Питання почуто`,
	THE_QUESTION_IS_NOT_HEARD: `Питання не почуто`,
	THE_QUESTION_TEXT_IS_NOT_SHOWN: `Текст питання не відображається`,
	THE_QUESTION_TEXT_IS_SHOWN: `Текст питання відображається`,
	THE_SUBSCRIPTION_PERIOD_WILL_BE_CHANGED_TO: `Термін дії підписки буде змінено на {period}`,
	THEORY_STEP: `Крок теоріі`,
	THEORY_STEP_INFORMATION_TEXT: `Текст інформації про крок`,
	TIME: `Час`,
	TITLE: `Заголовок`,
	TO: `до`,
	TO_GET_A: `Щоб отримати`,
	TODAY: `Сьогодні`,
	TOGGLE: `Перемикач`,
	TOTAL: `Всього`,
	TOTAL_USAGE_TIME: `Загальний час використання`,
	TRUE: `Правильно`,
	TRUE_FALSE: `Правильно / Неправильно`,
	TRY_AGAIN: `Спробувати знову`,
	TYPE: `Тип`,
	TYPE_INSTEAD: `Ввести текстом`,
	TYPE_OR_SAY_YOUR_ANSWER_HERE: `Введіть або проговоріть свою відповідь`,
	TYPE_YOUR_ANSWER_HERE: `Введіть свою відповідь`,
	UNASSIGNED_LICENSE: `Непризначені ліцензії`,
	UNFAVORITE_COURSE: `Скасувати позначку улюбленого курсу`,
	UNFORTUNATLY_WE_COULD_NOT_LOAD_THE_USER_DATA: `На жаль, ми не змогли завантажити дані користувача`,
	UNKNOWN: `Невідомо`,
	UNSUBSCRIBE: `Відписатися`,
	UNSUBSCRIBE_FAILED: `Не вдалося скасувати підписку`,
	UNSUBSCRIBED_SUCCESSFULLY: `Відписка успішно скасована`,
	UPDATE: `Оновити`,
	UPDATE_SUBSCRIPTION_PERIOD_FAILED: `Не вдалося оновити термін дії підписки`,
	UPDATE_SUBSCRIPTION_PERIOD_SUCCESS: `Термін дії підписки успішно оновлено`,
	USER_DETAILS: `Деталі користувача`,
	USER_MANAGEMENT: `Управління користувачами`,
	USER_MANAGMENT: `Управління користувачами(персонал)`,
	USER_NOT_FOUND: `Користувач не знайдений`,
	USERNAME: `Ім'я користувача`,
	USERNAME_OR_EMAIL: `Ім'я користувача/Електронна пошта`,
	USERS: `Користувачі`,
	USERS_LIST: `Список користувачів`,
	USER_NOT_LOGGED_IN: `Ви не ввійшли в систему`,
	VALID_EMAIL_ADDRESS: `Дійсна адреса електронної пошти`,
	VALID_UNTIL: `Дійсний до`,
	VALIDATE_INVALID_PHONE: `Потрібен дійсний мобільний телефон`,
	VALIDATE_MIN_2_CHARS: `Мінімум 2 симвои`,
	VALIDATE_MIN_2_MAX_20: `Значення повинно бути від 2 до 20 символів`,
	VERIFY: `Перевірка`,
	VIDEO_LOADING: `Завантаження відео…`,
	VIDEO_LOAD_ERROR: `Не вдалося завантажити відео`,
	VIEW_RESULTS: `Переглянути результати`,
	VIEW_STATISTICS: `Переглянути статистику`,
	WEELKLY: `Щотижня`,
	WELCOME_BACK_MESSAGE: `Готові продовжити свою навчальну подорож?`,
	WELCOME_BACK_MESSAGE_PARENT: `Ласкаво просимо назад! Виберіть дитину, щоб продовжити її навчальну подорож.`,
	WELCOME_BACK_MESSAGE_STUDENT: `Ласкаво просимо назад! Готові продовжити навчання?`,
	WELCOME_BACK_MESSAGE_TEACHER: `Ласкаво просимо назад! Ось огляд ваших класів.`,
	WELCOME_TO: `Ласкаво просимо до`,
	WHEN_YOU_HAVE_A_MISTAKE: `Коли у вас помилка`,
	WORD_BUILDER: `Склади слово`,
	WRONG_ANSWER: `Неправильна відповідь`,
	YEAR: `Рік`,
	YEARLY: `Щорічно`,
	YES: `Так`,
	YOU_CAN_CORRECT_YOUR_ANSWER_THE_QUESTION_WILL_REPEATE: `Ви можете виправити свою відповідь, питання повториться`,
	YOU_CAN_NOT_CORRECT_YOUR_ANSWER_THE_NEXT_QUESTION_WILL_BE_SHOWN: `Ви не можете виправити свою відповідь, наступне питання буде показано`,
	YOU_DID_GOOD_ON_PREVIOUS_STEPPS_THIS_FILTER_STEP_IS_NOT_NEEDED: `Ви добре справилися з попередніми кроками, цей крок не потрібен`,
	YOU_DID_GOOD_ON_PREVIOUS_STEPS: `Ви добре справилися з попередніми кроками`,
	YOU_DID_NOT_MEET_THE_TERMS_OF_TRANSITION_FOR_THE_SECTION_REDO: `Ви не виконали умови переходу для цього завдання, повторити?`,
	YOU_HAVE_COMPLETED_THIS_COURSE_BACK_TO_COURSES: `Ви закінчили цей курс! Повернутися до курсів`,
	YOU_HAVE_COMPLETED_THIS_SECTION_WOULD_YOU_LIKE_TO_PROCEED: `Ви завершили це завдання. Бажаєте продовжити?`,
	YOU_HAVE_COMPLETED_THIS_STEP: `Ви завершили цей крок`,
	YOU_WILL_BE_SHOWN_THE_ANSWER_COMPARISON: `Вам буде показано порівняння відповідей`,
	YOUR_ANSWER: `Ваша відповідь`,
	YOUR_SECTIONS: `Ваші завдання`,
	YOUR_SUBSCRIPTION_WILL_ONLY_UPDATE_THE_PRICE: `Ваша підписка буде оновлена лише за ціною`,
	ZIPCODE: `Поштовий індекс`,
}